import {Component, inject, OnInit} from "@angular/core";
import {Store} from "@ngrx/store";
import {AsyncPipe, CommonModule} from '@angular/common';
import {MenubarModule} from 'primeng/menubar';
import {ToolbarModule} from 'primeng/toolbar';
import {ButtonModule} from 'primeng/button';
import {MenuModule} from 'primeng/menu';
import {BadgeModule} from 'primeng/badge';
import {MatIconModule} from '@angular/material/icon';
import {TooltipModule} from 'primeng/tooltip';
import {SharedModule} from '../../../shared.module';
import {Observable, switchMap} from 'rxjs';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {FeatureState, selectFeatureStateForm} from '../../../../store';
import {map, startWith} from 'rxjs/operators';
import {environment} from '../../../../../environments/environment';
import {AppGuardType} from '../../../../tinea-components/okta/enum/AppGuardType';
import {UserSessionService} from '../../../../tinea-components/okta/services/session/user-session.service';
import {AuthService} from '../../../../tinea-components/okta/auth/auth.service';
import {MenuItem} from 'primeng/api';

@Component({
  selector: "app-header-menu-logged",
  templateUrl: "./header-menu-logged.component.html",
  styleUrls: ["./header-menu-logged.component.scss"],
  imports: [
    CommonModule,
    MenubarModule,
    ToolbarModule,
    AsyncPipe,
    ButtonModule,
    MenuModule,
    BadgeModule,
    TranslateModule,
    SharedModule,
    MatIconModule,
    TooltipModule
  ],
})
export class HeaderMenuLoggedComponent implements OnInit {
  public autAppGuard = environment.authAppGuard;
  public NotAuthenticatedJustLoggedIn = AppGuardType.NOT_AUTHENTICATED_JUST_LOGGEDIN;
  public toggleFeatureView$: Observable<FeatureState>;
  public itemsLogged$!: Observable<MenuItem[] | null>;

  readonly userSessionService = inject(UserSessionService);
  readonly currentUser$ = this.userSessionService.currentUser$;

  readonly acronym$ = this.currentUser$.pipe(
    map(user =>
      user?.uid
        ? `${user.firstName[0]}${user.lastName[0]}`
        : ''
    )
  );

  readonly userFullName$ = this.currentUser$.pipe(
    map(user =>
      user?.uid
        ? `${user.firstName} ${user.lastName}`
        : ''
    )
  );

  constructor(
    public authService: AuthService,
    private translateService: TranslateService,
    private readonly store: Store
  ) {
    this.toggleFeatureView$ = this.store.select(selectFeatureStateForm);
  }

  ngOnInit(): void {
    this.initializeMenu();
  }

  private initializeMenu(): void {
    this.itemsLogged$ = this.translateService.onLangChange.asObservable()
      .pipe(
        startWith(this.translateService.currentLang),
        switchMap(() => this.toggleFeatureView$),
        map((toggleFeatureView: FeatureState) => {
          const menus: any[] = [
            {
              label: this.translateService.instant("menu.logout"),
              icon: "fas fa-lock-open",
              command: () => this.onLogout(),
            },
          ];

          if (toggleFeatureView.displayNonImplementedMenus) {
            menus.push({
              label: this.translateService.instant("menu.informations"),
              routerLink: ['/informations'],
              icon: "fas fa-user",
            })
          }

          return menus;
        })
      )
  }

  onLogout(): void {
    this.authService.logout();
  }
}
